import * as React from "react";

type Props = React.HTMLProps<HTMLAnchorElement> & { href: string };

export const PrettyLink: React.FunctionComponent<Props> = (props: Props) => <a {...props}>{prettyLink(props.href)}</a>;

export const prettyLink = (href: string) => {
  return stripLastSlash(stripHash(stripQuery(stripProtocol(href))));
};

const splitOnAndTakeFirst = (delimiter: string) => (value: { split: (arg0: any) => any[]; }) => value.split(delimiter)[0];

const stripProtocol = (href: string) => href.replace(/(^\w+:|^)\/\//gi, "");

const stripQuery = splitOnAndTakeFirst("?");

const stripHash = splitOnAndTakeFirst("#");

const stripLastSlash = (href: string) => href.replace(/\/$/, "");
